import { DialogContent, makeStyles, withWidth } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";
import penarikanImg from "../../../assets/images/ilustrator/img_penarikandiproses.svg";
import { css, cx } from "emotion";
import { formatCurrency } from "../../../components/Utils/Currency";

function WithdrawSuccessDialog(props) {
  const { totalAmount, tenant, bank, handleGetList, width, proceed } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const tableStyle = css`
    border: none !important;
    margin-bottom: 0px !important;

    tr,
    tr td {
      border: none !important;
    }

    tr td {
      padding: 10px !important;
      text-align: left !important;
      vertical-align: top !important;
    }
  `;

  const handleCloseDialog = () => {
    handleGetList();
    setOpenDialog(false);
    proceed();
  };

  return (
    <div>
      <FullScreenDialog
        disableBackdropClick
        maxWidth="md"
        fullScreen={width === "xs"}
        title={props.title}
        scroll="body"
        open={openDialog}
        HiddenCloseIcon
      >
        <DialogContent style={{ padding: "24px", minWidth: 620 }}>
          <div className="row">
            <div className="col-12">
              <div className="d-flex flex-column justify-content-center align-items-center pt-5">
                <h3
                  className={cx(
                    css`font-size; 27px !important;`,
                    "font-bold text-primary"
                  )}
                >
                  Penarikanmu sedang diproses
                </h3>
                <p className="text-center font-11 text-muted">
                  Harap tunggu maks, 3x24 jam (hari kerja)
                </p>
                <img src={penarikanImg} alt="lock-icon" style={{ width: 212 }} />
                <div
                  className={cx(
                    css`
                      border-radius: 8px !important;
                      width: 95% !important;
                    `,
                    "p-3 border-1-secondary"
                  )}
                >
                  <p className="font-16 font-bold text-primary">
                    Detail penarikan saldo
                  </p>
                  <table className={cx(tableStyle, "table")}>
                    <tbody>
                      <tr>
                        <td width="30%" className="font-12">
                          Rekening Tujuan
                        </td>
                        <td width="70%">
                          <p className="font-12 font-bold text-primary mb-2">
                            {bank?.bank_name}
                          </p>
                          <p className="font-12 mb-0">
                            {tenant?.bank_account_name} -{" "}
                            {tenant?.bank_account_number}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%" className="font-12">
                          Total Penarikan
                        </td>
                        <td width="70%">
                          <p className="font-12 font-bold text-primary">
                            {formatCurrency(
                              tenant?.property?.currency ||
                                process.env.REACT_APP_CURRENCY_CODE,
                              totalAmount.toString()
                            )}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <button
                  type="button"
                  className={cx(
                    css`
                      border-radius: 8px !important;
                      border: none !important;
                      background-color: #2196f3 !important;
                      color: #ffffff !important;
                      padding: 14px 32px !important;
                    `,
                    "btn text-center font-12 font-bold mt-3"
                  )}
                  onClick={() => {
                    handleCloseDialog();
                  }}
                >
                  KEMBALI KE SALDO
                </button>
              </div>
            </div>
          </div>
        </DialogContent>
      </FullScreenDialog>
    </div>
  );
}

WithdrawSuccessDialog.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showWithdrawSuccessDialog(
  totalAmount,
  tenant,
  bank,
  handleGetList,
  options = {}
) {
  return createConfirmation(confirmable(withWidth()(WithdrawSuccessDialog)))({
    totalAmount,
    tenant,
    bank,
    handleGetList,
    ...options,
  });
}
